const TokenKey = "ldweb-dot-ooowin-token";
const PhoneKey = "ldweb-dot-ooowin-phone"
const NickNamekey = "ldweb-dot-ooowin-nickname"
const Constants = {
    TokenKey,
    PhoneKey,
    NickNamekey
}
export default Constants;